/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxAttachmentDTO } from './MailboxAttachmentDTO';
import {
    MailboxAttachmentDTOFromJSON,
    MailboxAttachmentDTOFromJSONTyped,
    MailboxAttachmentDTOToJSON,
    MailboxAttachmentDTOToJSONTyped,
} from './MailboxAttachmentDTO';
import type { MailboxItemDirection } from './MailboxItemDirection';
import {
    MailboxItemDirectionFromJSON,
    MailboxItemDirectionFromJSONTyped,
    MailboxItemDirectionToJSON,
    MailboxItemDirectionToJSONTyped,
} from './MailboxItemDirection';
import type { MailboxRecipientDTO } from './MailboxRecipientDTO';
import {
    MailboxRecipientDTOFromJSON,
    MailboxRecipientDTOFromJSONTyped,
    MailboxRecipientDTOToJSON,
    MailboxRecipientDTOToJSONTyped,
} from './MailboxRecipientDTO';
import type { MailboxItemStatus } from './MailboxItemStatus';
import {
    MailboxItemStatusFromJSON,
    MailboxItemStatusFromJSONTyped,
    MailboxItemStatusToJSON,
    MailboxItemStatusToJSONTyped,
} from './MailboxItemStatus';
import type { MailboxItemChannel } from './MailboxItemChannel';
import {
    MailboxItemChannelFromJSON,
    MailboxItemChannelFromJSONTyped,
    MailboxItemChannelToJSON,
    MailboxItemChannelToJSONTyped,
} from './MailboxItemChannel';
import type { MailboxItemLinkDTO } from './MailboxItemLinkDTO';
import {
    MailboxItemLinkDTOFromJSON,
    MailboxItemLinkDTOFromJSONTyped,
    MailboxItemLinkDTOToJSON,
    MailboxItemLinkDTOToJSONTyped,
} from './MailboxItemLinkDTO';

/**
 * 
 * @export
 * @interface MailboxItemDTO
 */
export interface MailboxItemDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    Id?: string;
    /**
     * 
     * @type {MailboxItemDirection}
     * @memberof MailboxItemDTO
     */
    Direction?: MailboxItemDirection;
    /**
     * 
     * @type {MailboxItemChannel}
     * @memberof MailboxItemDTO
     */
    Channel?: MailboxItemChannel;
    /**
     * 
     * @type {MailboxItemStatus}
     * @memberof MailboxItemDTO
     */
    Status?: MailboxItemStatus;
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    Sender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    Recipient?: string | null;
    /**
     * 
     * @type {Array<MailboxRecipientDTO>}
     * @memberof MailboxItemDTO
     */
    Recipients?: Array<MailboxRecipientDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    Subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    Body?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MailboxItemDTO
     */
    CreatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MailboxItemDTO
     */
    SentAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MailboxItemDTO
     */
    ReadAt?: Date | null;
    /**
     * 
     * @type {Array<MailboxItemLinkDTO>}
     * @memberof MailboxItemDTO
     */
    Links?: Array<MailboxItemLinkDTO> | null;
    /**
     * 
     * @type {Array<MailboxAttachmentDTO>}
     * @memberof MailboxItemDTO
     */
    Attachments?: Array<MailboxAttachmentDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    InReplyToId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxItemDTO
     */
    ConversationId?: string | null;
}



/**
 * Check if a given object implements the MailboxItemDTO interface.
 */
export function instanceOfMailboxItemDTO(value: object): value is MailboxItemDTO {
    return true;
}

export function MailboxItemDTOFromJSON(json: any): MailboxItemDTO {
    return MailboxItemDTOFromJSONTyped(json, false);
}

export function MailboxItemDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'] == null ? undefined : json['Id'],
        'Direction': json['Direction'] == null ? undefined : MailboxItemDirectionFromJSON(json['Direction']),
        'Channel': json['Channel'] == null ? undefined : MailboxItemChannelFromJSON(json['Channel']),
        'Status': json['Status'] == null ? undefined : MailboxItemStatusFromJSON(json['Status']),
        'Sender': json['Sender'] == null ? undefined : json['Sender'],
        'Recipient': json['Recipient'] == null ? undefined : json['Recipient'],
        'Recipients': json['Recipients'] == null ? undefined : ((json['Recipients'] as Array<any>).map(MailboxRecipientDTOFromJSON)),
        'Subject': json['Subject'] == null ? undefined : json['Subject'],
        'Body': json['Body'] == null ? undefined : json['Body'],
        'CreatedAt': json['CreatedAt'] == null ? undefined : (new Date(json['CreatedAt'])),
        'SentAt': json['SentAt'] == null ? undefined : (new Date(json['SentAt'])),
        'ReadAt': json['ReadAt'] == null ? undefined : (new Date(json['ReadAt'])),
        'Links': json['Links'] == null ? undefined : ((json['Links'] as Array<any>).map(MailboxItemLinkDTOFromJSON)),
        'Attachments': json['Attachments'] == null ? undefined : ((json['Attachments'] as Array<any>).map(MailboxAttachmentDTOFromJSON)),
        'InReplyToId': json['InReplyToId'] == null ? undefined : json['InReplyToId'],
        'ConversationId': json['ConversationId'] == null ? undefined : json['ConversationId'],
    };
}

export function MailboxItemDTOToJSON(json: any): MailboxItemDTO {
    return MailboxItemDTOToJSONTyped(json, false);
}

export function MailboxItemDTOToJSONTyped(value?: MailboxItemDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'Direction': MailboxItemDirectionToJSON(value['Direction']),
        'Channel': MailboxItemChannelToJSON(value['Channel']),
        'Status': MailboxItemStatusToJSON(value['Status']),
        'Sender': value['Sender'],
        'Recipient': value['Recipient'],
        'Recipients': value['Recipients'] == null ? undefined : ((value['Recipients'] as Array<any>).map(MailboxRecipientDTOToJSON)),
        'Subject': value['Subject'],
        'Body': value['Body'],
        'CreatedAt': value['CreatedAt'] == null ? undefined : ((value['CreatedAt']).toISOString()),
        'SentAt': value['SentAt'] === null ? null : ((value['SentAt'] as any)?.toISOString()),
        'ReadAt': value['ReadAt'] === null ? null : ((value['ReadAt'] as any)?.toISOString()),
        'Links': value['Links'] == null ? undefined : ((value['Links'] as Array<any>).map(MailboxItemLinkDTOToJSON)),
        'Attachments': value['Attachments'] == null ? undefined : ((value['Attachments'] as Array<any>).map(MailboxAttachmentDTOToJSON)),
        'InReplyToId': value['InReplyToId'],
        'ConversationId': value['ConversationId'],
    };
}

